import { component_tool, framework_tool, utils_tool } from '@/tool';
import React from 'react';

let { WizModal } = component_tool;
let ref
//配置项
let componentName = 'thirdCopr'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {
      rules: [{
        required: true,
        message: '请输入名称',
      }],
    
      maxlength: 30,
      placeholder: "名称不能超过30个字。"},
    tableItem: {}
  },
  
  {
    title: "登录类型",
    name: "loginType",
    dataIndex: "loginType",
    tableItem: {},
    dict: [
      { code: 1, codeName: "企业号" },
      { code: 2, codeName: "微信" },
      { code: 3, codeName: "微博" },
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "select",
      
      rules: [{
        required: true,
        message: '请选择登录类型',
      }]
    }
  },
  {
    title: "企业id",
    name: "corpId",
    dataIndex: "corpId",
    formItem: {
      rules: [{
        required: true,
        message: '请输入企业id',
      }],
    
      maxlength: 40,
      placeholder: "企业id不能超过40个字符"
    },
    tableItem: {}
  },
  {
    title: "描述",
    name: "remark",
    dataIndex: "remark",
    formItem: {
      maxlength: 100,
      placeholder: "描述不能超过100个字符"},
    tableItem: {}
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 12
        },
        buttonSort:['add','delete'],

      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort:['update','appEdit', 'userEdit'],
      rowOperateView: [
        {
          key: "appEdit",
          custom: true,
          params: { children: "企业应用管理" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/auth/corpManager/appManager",
            },
          },
        },
        {
          key: "userEdit",
          custom: true,
          params: { children: "企业应用人员管理" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/auth/corpManager/userManager",
            },
          },
        },
      ],
      commonOperate: {
        add: true,
        delete:true,
        update:true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
  add:{
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
    }
  },
  delete:{
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
    }
  },
  update:{
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: false,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
